/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/lokasi-mitra?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/lokasi-mitra`;
    return http.post(url, payload.params);
  },

  async detail({}, payload) {
    const url = `/lokasi-mitra/${payload.id}`;
    return await http.get(url).then(({ data }) => data);
  },

  update({}, payload) {
    const url = `/lokasi-mitra/${payload.id}`;
    return http.patch(url, payload.params);
  },

  status({}, payload) {
    const url = `/lokasi-mitra/${payload.id}/${payload.status}`;
    return http.post(url);
  },

  delete({}, payload) {
    const url = `/lokasi-mitra/${payload.id}`;
    return http.delete(url);
  },
};
